module.exports = __webpack_public_path__ + "img/img4.5e8ee272.png";